import { defineComponent as _defineComponent } from 'vue'
import { useAmplitude } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppDownloadBanner',
  setup(__props) {

const branchUrl = "https://ltk.app.link/fLHsPHg3MR";
const amplitude = useAmplitude();

function onAppClick() {
  amplitude?.sendExitEvent("/open-app", {
    "referring-component": "custom-banner",
  });
}

return { __sfc: true,branchUrl, amplitude, onAppClick }
}

})